import { Component } from '@angular/core';
import {ForgotPasswordComponent} from "../../component/forgot-password/forgot-password.component";

@Component({
  selector: 'app-forgot-password-view',
  standalone: true,
  imports: [
    ForgotPasswordComponent
  ],
  templateUrl: './forgot-password-view.component.html',
  styleUrl: './forgot-password-view.component.scss'
})
export class ForgotPasswordViewComponent {

}
